<template>
  <div class="vx-card">
    <div class="vx-card__body card-body">
      <form>
        <div class="vx-row mb-2">
          <vx-card>
            <vs-tabs vs-alignment="fixed" alignment="fixed">
              <vs-tab label="اطلاعات کلی">
                <GeneralInformation :promoter="promoter"></GeneralInformation>
              </vs-tab>
              <vs-tab label="تراکنش‌ها">
                <TransactionsTab :promoter="promoter"></TransactionsTab>
              </vs-tab>
              <vs-tab label="محصولات فروخته شده">
                <ProductsSold :promoter="promoter"></ProductsSold>
              </vs-tab>
              <vs-tab label="بیننده ها">
                <Visitors></Visitors>
              </vs-tab>
            </vs-tabs>
          </vx-card>
        </div>
      </form>
    </div>
  </div>
</template>
<style lang="scss">
#assign-product-popup {
  overflow-y: scroll !important;
}
.add-btn {
  margin-top: 1.5rem;
}
.alignment-menu {
  display: inline-flex;
  padding: 0 1em;
  border-radius: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid rgb(202, 202, 202);
  background-color: rgb(230, 230, 230);
  height: 3em;
}
.label {
  display: inline-block;
  color: black;
  border-radius: 4px;
  transition: all 0.1s ease;
  width: 10em;
  text-align: center;
  align-content: center;
  padding-top: 10px;
  height: 100%;

  &:hover,
  &:focus {
    background-color: #9fd4b1;
  }

  &:active {
    background-color: #ceeed8;
    transition: border-color 0.1s ease, background-color 0s;
    border: none;
  }
}

#definitionDiscountTypeInput,
#definitionCommissionTypeInput {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  white-space: nowrap;
  width: 1px;

  &:checked + .label {
    background-color: #007470;
    color: white;
  }
}
#definitionDiscountTypeInput,
#definitionCommissionTypeInput {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  white-space: nowrap;
  width: 1px;

  &:checked {
    background-color: #007470;
    color: white;
  }
}
</style>

<script>
import { mapActions } from "vuex";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import GeneralInformation from "./DetailsSalePartner/GeneralInformation.vue";
import TransactionsTab from "./DetailsSalePartner/TransactionsTab.vue";
import ProductsSold from "./DetailsSalePartner/ProductsSold.vue";
import Visitors from "./DetailsSalePartner/Visitors.vue";

export default {
  data() {
    return { searchQueryNew: "", searchQueryOld: "" };
  },
  methods: {
    ...mapActions({
      searchProduct: "productQuery/productQuery",
      unassignProduct: "SalesPartnerPlan/unassignProduct",
      createProductsPlan: "SalesPartnerPlan/createProductsPlan",
    }),
    loadOptions({ searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          this.searchProduct(searchQuery).then((response) => {
            const options = [];
            response.forEach(function (element) {
              options.push({
                id: element.id,
                label: element.persianName + "   ---   " + element.name,
              });
            });
            callback(null, options);
          });
        }
      }, 2000);
    },
    onfinish() {
      this.showPlanList = false;
      this.$refs.grid.renderGrid();
    },
    definitionDiscountType(DiscountTypeValue) {
      this.DiscountTypeId = DiscountTypeValue;
    },
    definitionCommissionType(CommissionTypeValue) {
      this.CommissionTypeId = CommissionTypeValue;
    },
    onActualProductSelected(data) {
      this.labels = data.label.split("   ---   ");
      this.labelPersian = this.labels[0];
      this.labelEnglish = this.labels[1];
      this.productInfo.actualProductId = data.id;
      this.product = null;
    },
    onUnassignProduct(row) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          var promoterPlanId = this.currentPlan.id;
          var saleProductId = row.beneficiaryRuleProductInfoQuery.saleProductId;
          this.unassignProduct({ promoterPlanId, saleProductId }).then(() => {
            this.$refs.grid1.renderGrid();
          });
        }
      });
    },
    addedProduct() {
      this.model = {
        promoterPlanId: this.currentPlan.id,
        commissionInfoCommand: {
          amount: this.commissionValue,
          commissionType: this.CommissionTypeId,
        },
        discountInfoCommand: {
          amount: this.discountValue,
          productDiscountType: this.DiscountTypeId,
        },
        beneficiaryRuleProductInfoCommand: {
          saleProductId: this.productInfo.actualProductId,
          saleProductPersianName: this.labelPersian,
          saleProductEnglishName: this.labelEnglish,
        },
      };
      if (this.discountValue == 0 && this.commissionValue == 0) {
        this.$swal({
          position: "center-center",
          type: "warning",
          text: "امکان ثبت کالایی با کمیسیون و تخفیف صفر وجود ندارد!",
          showConfirmButton: false,
          timer: 2000,
        });
      } else {
        this.createProductsPlan(this.model).then(() => {
          this.$refs.grid1.renderGrid();
          this.$refs.product.clear();
          this.commissionValue = 0;
          this.discountValue = 0;
          this.DiscountTypeId = 1;
          this.CommissionTypeId = 1;
        });
      }
    },
  },

  components: {
    GeneralInformation,
    TransactionsTab,
    ProductsSold,
    DataGrid,
    Visitors,
    "v-select": vSelect,
  },
};
</script>
